import { render, staticRenderFns } from "./InviteUsersDialog.vue?vue&type=template&id=3d145ffe&scoped=true"
import script from "./InviteUsersDialog.ts?vue&type=script&lang=ts&external"
export * from "./InviteUsersDialog.ts?vue&type=script&lang=ts&external"
import style0 from "./InviteUsersDialog.scss?vue&type=style&index=0&id=3d145ffe&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d145ffe",
  null
  
)

export default component.exports